export default {"src":"/_next/static/media/twitter.2f2f5b75.svg","height":20,"width":22};